import type React from 'react'
import { isValidElement, cloneElement } from 'react'
import { Input } from '@/common/ui/Form/Input'
import { Textarea } from '@/common/ui/Form/Textarea'
import { Select } from '@/common/ui/Form/Select'

export type FieldsetProps = {
    children: React.ReactNode
    label?: string
    required?: boolean
    helpText?: string
    error?: boolean
    errorText?: string
} & React.FieldsetHTMLAttributes<HTMLFieldSetElement>

export const Fieldset = ({ children, label, required, helpText, error, errorText, ...props }: FieldsetProps) => {
    error = error || !!errorText

    const renderChildren = () => {
        if (!isValidElement(children)) return children

        if (error && (children.type === Input || children.type === Textarea || children.type === Select)) {
            return cloneElement(children, {
                emphasis: 'negative',
                ...children.props,
            })
        }
        return children
    }

    return (
        <fieldset {...props}>
            {label && (
                <legend className='fieldset-legend'>
                    {label}
                    {required && <span className='label-required'>*</span>}
                </legend>
            )}
            {renderChildren()}
            {error && <div className='label label-error'>{errorText}</div>}
            {helpText && <div className='label'>{helpText}</div>}
        </fieldset>
    )
}
